import { Component, computed, input } from '@angular/core';

const TONE_MAP: Record<string, 'neutral' | 'positive' | 'negative' | 'warning'> = {
  PENDING_APPROVAL: 'warning',
  APPROVED_PROCESSING: 'neutral',
  IN_PROGRESS: 'neutral',
  SUCCESS: 'positive',
  REJECTED: 'negative',
  FAILED: 'negative',
  REVERSED: 'negative',
  HOLD_ERROR: 'negative',
};

@Component({
  selector: 'app-status-badge',
  imports: [],
  templateUrl: './status-badge.html',
  styleUrl: './status-badge.scss',
})
export class StatusBadge {
  readonly state = input.required<string>();
  readonly tone = computed(() => TONE_MAP[this.state()] ?? 'neutral');
  readonly label = computed(() =>
    this.state()
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (c) => c.toUpperCase()),
  );
}
